export default [
  {
    path: '/traceability-desc',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'TraceabilityDesc',
        component: () => import('./containers/TraceabilityDescContainer'),
      },
    ],
  },
]
